var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMoodleInactive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 35,
    viewBox: "0 0 52 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.6868 35V18.8974C43.6868 15.5319 42.2789 13.8486 39.463 13.8477C36.6472 13.8467 35.2363 15.5299 35.2303 18.8974V35H26.9111V18.8974C26.9111 15.5319 25.5248 13.8486 22.7522 13.8477C19.9314 13.8477 18.5235 15.5309 18.5285 18.8974V35H10.2078V17.9469C10.2078 14.4337 11.4447 11.7747 13.9186 9.97C16.0968 8.35865 19.0414 7.55298 22.7522 7.55298C26.5143 7.55298 29.2859 8.50442 31.0669 10.4073C32.6015 8.50442 35.3982 7.55298 39.457 7.55298C43.1679 7.55298 46.1114 8.35865 48.2876 9.97C50.7615 11.7737 51.9989 14.4327 51.9999 17.9469V35H43.6868Z",
    fill: "#B0B0B0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.359 6.31252L34.6164 0.362926L34.5108 0C19.6101 1.80124 12.8341 3.07743 0 10.4133L0.119169 10.7465L1.1389 10.7569C1.04537 11.7698 0.882456 14.2731 1.09062 18.0377C-0.333372 22.1013 1.05442 24.8619 2.35774 27.8649C2.5644 24.7414 2.54328 21.3204 1.57032 17.9157C1.36667 14.1764 1.53412 11.7177 1.62613 10.7613L10.1339 10.8417C10.111 12.4844 10.1952 14.1269 10.3858 15.759C17.9885 18.3932 25.635 15.7501 29.6943 9.25609C28.5674 8.01113 26.359 6.31252 26.359 6.31252Z",
    fill: "#606060"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoodleInactive);
export default __webpack_public_path__ + "static/media/moodle-inactive.31db9a99f7008e6fdbeb3e6c4086cf20.svg";
export { ForwardRef as ReactComponent };